import React from 'react';

const BtnToggle = ({
  className = '',
  onChange,
  value = false,
  children,
}) => {
  const classes = [
    'btn',
    className,
  ];

  if (value) classes.push('active');

  return (
    <button
      className={classes.join(' ')}
      onClick={(evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        onChange(!value);
      }}
    >{children}</button>
  );
};

export default BtnToggle;
